import { Component, OnInit } from '@angular/core';
import { User } from '../user';
import { UserService } from '../user.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { Router} from '@angular/router';
import { UtilityService } from  '../../utility.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.css']
})
export class CreateUserComponent implements OnInit {

  user = new User();
  userdata : any = {}
  department: any [];
  userroles: any [];
  submitted = false;
  userForm: FormGroup;
  public isupdate = false;
  public FormName = "Add a User";
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder, 
    private util:UtilityService, 
    private location: Location,
    private auth: AuthService
  ) { }

  onSubmit() {
    this.submitted = true;
    this.userForm = this.formBuilder.group({			
      username: [this.user.username,[Validators.required, Validators.required]],
      usertitle: [this.user.usertitle,[Validators.required, Validators.required]],
      deptid: [this.user.deptid,[Validators.required, Validators.required]],
      userroletypeid: [this.user.userroletypeid,[Validators.required, Validators.required]],
	  emailid: [this.user.emailid,[Validators.required, Validators.required]],
	  password: [this.user.password,[Validators.required, Validators.required]]
    });	
    // stop here if form is invalid
    if (this.userForm.invalid) {
        return this.util.showError("Please enter required fields.");		
    }
  else{
    if(this.isupdate){
      this.update();
    }
    else{
      this.addUser();
    }
  }
}

  addUser() {
  //  this.submitted = true;
    this.save();
  }
  private save(): void {
    this.userdata = this.user;
   this.userdata.createdby = this.auth.currentUserValue.userid
    this.userService.addUser(this.userdata)
        .subscribe(() => {
    
		 this.util.showSuccess("User added successfully.") 
		 this.router.navigate(['/user-list']);   
		});
  }
 
  
  update(): void {
    //this.submitted = true;
    this.submitted = true;
    this.userdata = this.user;
    this.userdata.modifiedby = this.auth.currentUserValue.userid;
    this.userdata.modifiedon = Date.now();
    this.userService.updateUser(this.userdata)
        .subscribe(() =>
		{
		this.util.showSuccess("User update successfully.");
        this.router.navigate(['/user-list']);
		});
  }

  ngOnInit() {
    this.getdepartment();
    this.getuserrole();
	this.user.active=1;
    if(this.route.snapshot.paramMap.get('userId') != null)
    {
      const userId = +this.route.snapshot.paramMap.get('userId');
       if(userId > 0)
       {
         this.getUser(userId);
       }
       this.isupdate = true;
       this.FormName = "Update User";				 
    }
    
    this.userForm = this.formBuilder.group({			
      username: [this.user.username,[Validators.required, Validators.required]],
      usertitle: [this.user.usertitle,[Validators.required, Validators.required]],
      deptid: [this.user.deptid,[Validators.required, Validators.required]],
      userroletypeid: [this.user.userroletypeid,[Validators.required, Validators.required]],
	   active: [this.user.active,[Validators.required, Validators.required]],
      emailid: [this.user.emailid,[Validators.required, Validators.email, Validators.pattern(this.emailPattern)]],
      password: [this.user.password,[Validators.required, Validators.required]]
    });	
  }
   // convenience getter for easy access to form fields
   get f() {
    return this.userForm.controls
    }
  
  getdepartment() {
    return this.userService.getdepartment()
               .subscribe(
                dept => {                  
                  this.department = dept				  
                 }
                );
 }

 getuserrole() {
  return this.userService.getuserrole()
             .subscribe(
              userrole => {                  
                this.userroles = userrole				  
               }
              );
}
getUser(userid) {
  return this.userService.getUser(userid)
             .subscribe(
              user => {                  
                this.user = user			  
               }
              );
}

}
